module.exports = __webpack_public_path__ + "img/vector.4c22bab3.svg";